import React, { Component } from "react";

import PersonEditCard from "../elements/PersonEditCard";
import classNames from "classnames";
import db from "../../api/db";
import CircularProgress from "@material-ui/core/CircularProgress";

class PersonEdit extends Component {
  constructor(props) {
    super(props);
    this.state = {
      string: "",
      results: [],
      total: 0,
      person: "",
      loading: true,
      size: 100
    };
    this.handleChange = this.handleChange.bind(this);
    this.setClear = this.setClear.bind(this);
  }

  componentDidMount() {
    const id = this.props.match.params.id ? this.props.match.params.id : "";
    this.setState({
      person: id
    });
    this.search_input.focus();
    this.searchQuery(this.state.string);
  }

  handleChange(event) {
    this.setClear();
    if (event.target.name === "string") {
      this.setState({
        string: event.target.value
      });
      this.searchQuery(event.target.value);
    }
  }

  searchQuery(string = this.state.string) {
    let query = {
      fleng: true,
      pagination: {
        size: this.state.size,
        from: 0
      },
      _sort: {
        update_local: "desc"
      }
    };
    this.setState({
      loading: true
    });

    if (string.length) {
      query["text"] = string;
    }

    db.query("person", query).then(response => {
      this.setState({
        results: response.data.hits,
        total: response.data.total,
        loading: false
      });
    });
  }

  setClear() {
    this.setState({
      person: ""
    });
    this.props.history.push("/person");
  }

  setPerson(id) {
    this.setState({
      person: id
    });
    this.props.history.push(`/person/${id}`);
  }

  createNew() {
    this.setState({
      person: "new"
    });
    this.props.history.push("/person/new");
  }

  render() {
    let persons = "";
    let personsLength = 0;

    if (this.state.total) {
      personsLength = this.state.results.length;
      persons = this.state.results.map((item, i) => (
        <div
          key={i}
          data-id={item.id}
          onClick={e => this.setPerson(item.id)}
          className={classNames("item", {
            active: this.state.person === item.id
          })}
        >
          <div className="t2">
            {item.alias ? `${item.alias} (${item.fullname})` : item.fullname}
          </div>
        </div>
      ));
    }
    return (
      <div className="main-container">
        <div className="primary-content">
          <div className="grid-x">
            <div className="medium-3 cell">
              <div className="sidebar-right listing">
                <button
                  className="float-right button link black"
                  onClick={e => this.createNew()}
                >
                  Opprett Internasjonal Person
                </button>
                <div className="heading">Velg person</div>
                <label>
                  <input
                    className="search-input"
                    placeholder="Søk etter person"
                    name="string"
                    type="text"
                    value={this.state.string}
                    onChange={this.handleChange}
                    ref={input => {
                      this.search_input = input;
                    }}
                  />
                </label>
                <div className="metainfo">
                  {this.state.total} personer{" "}
                  {this.state.total > personsLength
                    ? `(Viser de ${personsLength} første)`
                    : ""}
                </div>
                {this.state.loading ? (
                  <CircularProgress size={20} />
                ) : (
                  <div className="list">{persons}</div>
                )}
              </div>
            </div>
            <div className="medium-7 cell">
              {this.state.person ? (
                <PersonEditCard
                  person={this.state.person}
                  clear={this.setClear}
                  setPerson={this.setPerson}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default PersonEdit;
